import React, { useContext, useEffect, useState } from 'react';
import { EventDetailsContext } from '../../context/event_details.context';
import CountDown from '../count_down/count_down';
import styles from './attending_info.module.scss';
import { EVENTS_PATH } from '../../../utilities/devex_paths';

const streamingWindow = 60 * 60 * 1000 * 4; // 4 hours
const preEventWindow = 60 * 60 * 1000; // 1 hour

// Any change here should be aligned with the BE method `accessible_for_streaming?`:
// https://github.com/Devex/grape-api/blob/master/app/models/event.rb
const evaluateStreamingAccess = (event) => {
  const now = Date.now();
  const startsAt = new Date(event?.starts_at).getTime();
  const endsAt = event?.ends_at ? new Date(event.ends_at).getTime() : null;
  const hasStreamingUrl = !!event?.streaming_url;

  const streamingTooOld = endsAt === null && startsAt < now - streamingWindow;
  const eventEnded = (endsAt !== null && endsAt <= now) || streamingTooOld;
  const tooFarInFuture = startsAt > now + preEventWindow;

  const accessibleForStreaming =
    hasStreamingUrl && !streamingTooOld && !eventEnded && !tooFarInFuture;

  return {
    started: now >= startsAt,
    finished: eventEnded,
    accessibleForStreaming: accessibleForStreaming,
  };
};

const AttendingInfo: React.FC = () => {
  const { event } = useContext(EventDetailsContext);

  const [started, setStarted] = useState(false);
  const [finished, setFinished] = useState(false);
  const [accessibleForStreaming, setAccessibleForStreaming] = useState(false);

  useEffect(() => {
    const checkTime = () => {
      const {
        started: isStarted,
        finished: isFinished,
        accessibleForStreaming: isAccessible,
      } = evaluateStreamingAccess(event);
      setStarted(isStarted);
      setFinished(isFinished);
      setAccessibleForStreaming(isAccessible);
    };

    checkTime();
    const interval = setInterval(checkTime, 1000);
    return () => clearInterval(interval);
  }, [event?.starts_at, event?.ends_at]);

  const AttendNowButton = () => (
    <a
      className='btn btn-primary'
      href={`${EVENTS_PATH}/${event?.id}/attend`}
      title='Join event'
      target='_blank'
      rel='noopener noreferrer'
    >
      Join event
    </a>
  );

  return (
    <div className={styles.attendingInfo} data-testid='attending-info'>
      <div className={`${styles.attending} mt-3`}>
        {finished ? 'Attended' : 'Attending'} &#10003;
      </div>

      {!started && (
        <div className='mt-3'>
          <span className={styles.infoText}>Event starts in:</span>
          <CountDown />
        </div>
      )}

      {accessibleForStreaming ? (
        <div className='mt-3'>
          <AttendNowButton />
        </div>
      ) : (
        !started &&
        !finished &&
        event.streaming_url && (
          <div className='bg-dark text-white mt-4 p-3 mx-3 rounded d-inline-flex'>
            The link to join the event will be displayed here one hour before the start time
          </div>
        )
      )}
    </div>
  );
};

export default AttendingInfo;
